export default __webpack_public_path__ + "static/media/HDI-color.bf1912aa.svg";